import { AlertCircle } from "lucide-react"
import { useTranslation } from "react-i18next"

export const PageNotFound = () => {
  const { t } = useTranslation()

  return (
    <div className="h-screen" data-testid="not-found-page">
      <div className="flex h-full flex-col items-center justify-center">
        <AlertCircle className="h-16 w-16 text-muted-foreground" />
        <div className="h-6" />
        <h1 className="text-2xl font-bold">{t("pageNotFound")}</h1>
      </div>
    </div>
  )
}
